import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-bold" }
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-nucleus-grey font-normal align-right"
}
const _hoisted_3 = { class: "text-nucleus-grey" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: "block bg-nucleus-white hover:bg-nucleus-listBgHover hover:border-nucleus-listBgHover p-3 text-nucleus-text rounded transition flex border border-nucleus-white mb-1 link",
    to: _ctx.to
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["icon text-3xl leading-none p-2 mr-6 flex self-center transition rounded-full", ['icon-' + _ctx.icon, _ctx.getIconColour()]])
      }, null, 2),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.name) + "  ", 1),
          (_ctx.allowance)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                _createTextVNode(_toDisplayString(_ctx.allowance.used) + " ", 1),
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-nucleus-lightGrey font-bold" }, "|", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.allowance.remaining) + " ", 1),
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-nucleus-lightGrey font-bold" }, "|", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("pages.usage.expires", { expiry: _ctx.allowance.licenseExpiry })), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.getRoleName(_ctx.room)), 1),
        _createElementVNode("div", {
          class: _normalizeClass(["text-sm mt-1", _ctx.getStatusColor()])
        }, _toDisplayString(_ctx.getStatusName(_ctx.status)), 3)
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}